//eslint-disable-next-line
import {CA_SUCCESS} from '../get-audits/constants'
import {createAudit as createAuditAPI} from '../../../services/audits'
//eslint-disable-next-line
import {getAudits as getAuditsAPI} from '../../../services/audits'

export async function createAudit(data, searchParams, dispatch) {
  try {
    let response = await createAuditAPI(data)
    // let response = await getAuditsAPI(searchParams)
    // dispatch({type: CA_SUCCESS, payload: response})
    return response
  } catch (e) {
    console.log(`Create Audit Failed: ${data.name}`)
    return e.response
  }
}
